export default "__VITE_ASSET__eb45bd78__"